import { useEffect, useState } from 'react';
import axios from 'axios';
import { urlConfig } from '../../config/urlConfig';
import Cookies from 'js-cookie';

const useFetch = (url) => {
  const [data, setData] = useState(null);
  const [isPending, setIsPending] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const abortController = new AbortController();
    Cookies.get('refresh_token') &&
      axios
        .post(urlConfig.refresh_token_url, {
          refresh: Cookies.get('refresh_token'),
          signal: abortController.signal,
        })
        .then((res) => {
          axios
            .get(url, {
              signal: abortController.signal,
              headers: {
                Authorization: `Bearer ${res.data.access}`,
              },
            })
            .then((res) => {
              if (!res.statusText === 'OK') {
                throw Error('could not fetch the data for that resource');
              }
              return res.data;
            })
            .then((data) => {
              setData(data);
              setError(null);
              setIsPending(false);
            })
            .catch((err) => {
              if (err.name === 'AbortError') {
              } else {
                setError(err.message);
                setIsPending(false);
              }
            });
          return () => abortController.abort();
        })
        .catch((err) => {
          if (err) {
            setError(err.toString());
          } else {
            setError(err.message);
            setIsPending(false);
          }
        });

    return () => abortController.abort();
  }, [url]);
  return { data, isPending, error };
};

export default useFetch;
